import { Skeleton } from "@/core/components/ui/skeleton/skeleton";
import { cn } from "@/core/utils/utils";

interface LoadingCountProps {
  className?: string;
  count?: number;
  isCountLoading?: boolean;
  variant?: "default" | "subtle";
  size?: "default" | "small";
  showParentheses?: boolean;
}

export const LoadingCount = ({
  className,
  count,
  isCountLoading,
  variant = "default",
  size = "default",
  showParentheses = false,
}: LoadingCountProps) => {
  if (isCountLoading) {
    return (
      <span
        className={cn(
          "inline-flex items-center gap-1 font-normal",
          variant === "default" ? "text-secondary-text" : "text-tertiary-text",
          !showParentheses && "ml-1",
          className,
        )}
      >
        {showParentheses && "("}
        <Skeleton
          variant="inline"
          className={cn("h-2 w-6", size === "small" && "h-1 w-4")}
        />
        {showParentheses && ")"}
      </span>
    );
  }

  if (count === undefined || count === null) return null;

  return (
    <span
      className={cn(
        "font-normal",
        variant === "default" ? "text-secondary-text" : "text-tertiary-text",
        className,
      )}
    >
      ({count})
    </span>
  );
};
